const resource = {
    resource_identifier_in_use: 'รหัสประจำตัว API {{indicator}} ถูกใช้งานไปแล้ว',
    cannot_delete_management_api: 'ไม่สามารถลบ Logto Management API ได้',
    cannot_modify_management_api: 'ไม่สามารถแก้ไข Logto Management API ได้',
};
export default Object.freeze(resource);
